export const isLetters = (value: any) => {
  if (!value || value === null) return false
  const lettersRegex = /^[a-zA-Z\s]*$/
  return lettersRegex.test(value)
}

export default isLetters
